/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_EmptyInputs */

const vi_movement_breakdown_empty = /** @type {(inputs: Movement_Breakdown_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có biến động trong kỳ`)
};

/**

* @param {Movement_Breakdown_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_empty = /** @type {((inputs?: Movement_Breakdown_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_empty(inputs)
});